import { type ParticipantDocument, ParticipantDocumentStatus } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaAngleDown } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { ParticipantDocumentChangeStatusModal } from './ParticipantDocumentChangeStatusModal';
import {
  ParticipantDocumentStatusTag,
  participantDocumentStatusColorName,
} from './ParticipantDocumentStatusTag';

interface Props extends ChakraV3.ButtonProps {
  participantDocument: ParticipantDocument;
}

export const ParticipantDocumentStatusMenu = (props: Props) => {
  const { participantDocument, ...rest } = props;

  const onClick = async (status: ParticipantDocumentStatus) => {
    showModal(ParticipantDocumentChangeStatusModal, {
      participantDocument,
      status,
    });
  };

  const [color, currentStatus] = participantDocumentStatusColorName(participantDocument.status);
  const statuses = Object.values(ParticipantDocumentStatus).map((status) => {
    return (
      <ChakraV3.MenuItem
        onClick={() => onClick(status)}
        value={status}
        key={status}
        disabled={participantDocument.status === status}
      >
        <ParticipantDocumentStatusTag status={status} />
      </ChakraV3.MenuItem>
    );
  });

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button variant='plain' size='sm' {...rest}>
          <ChakraV3.Tag size='sm' colorPalette={color} endElement={<FaAngleDown />}>
            {currentStatus}
          </ChakraV3.Tag>
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>{statuses}</ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
